import { Image } from '@epilot/concorde-elements'
import classNames from 'classnames'
import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'

import classes from '../../../styles/ProductImage.module.scss'

export const ProductImageCommon = ({
  className,
  alt,
  ...props
}: ComponentProps<typeof Image>) => {
  /* Products should always have a name, but as a fallback we use the default alt text */
  const { t } = useTranslation()

  return (
    <Image
      alt={alt ?? t('product.selection.image_default_alt', 'Product image')}
      className={classNames(classes.image, className)}
      {...props}
    />
  )
}
